// Intl вместо date-fns: format + локаль ru тянули в стартовый бандл ~30 КБ
const shortDateTimeFormat = new Intl.DateTimeFormat('ru-RU', {
  day: 'numeric',
  month: 'short',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

/** «1 авг, 12:22»: сокращённый месяц без точки, время в 24-часовом формате. */
export const formatShortDateTime = (dateVal: Date | string | number) =>
  shortDateTimeFormat.format(new Date(dateVal)).replace('.,', ',');
